import React, {
  useState,
} from 'react';

import {
  Form,
  Input,
  Button,
  Checkbox,
  Typography,
  message,
} from 'antd';

import {
  UserOutlined,
  MailOutlined,
  LockOutlined,
  ArrowRightOutlined,
  SafetyOutlined,
  BarChartOutlined,
  LoginOutlined,
} from '@ant-design/icons';

import {
  useNavigate,
} from 'react-router-dom';

import {
  Lotto649Logo,
  LottoMaxLogo,
  RouletteLogo,
} from '../../components/ProductLogo';

import './index.scss';


const { Text } = Typography;


/* =========================================================
   Product Brand Bar
========================================================= */

function ProductBrandBar() {

  return (

    <div className="register-product-brand-bar">

      <div className="register-product-logo">

        <Lotto649Logo
          height={38}
        />

      </div>


      <div className="register-brand-divider" />


      <div className="register-product-logo">

        <LottoMaxLogo
          height={38}
        />

      </div>


      <div className="register-brand-divider" />


      <div className="register-product-logo">

        <RouletteLogo
          height={38}
        />

      </div>

    </div>

  );

}


/* =========================================================
   Register
========================================================= */

export default function Register() {

  const navigate =
    useNavigate();


  const [
    submitting,
    setSubmitting,
  ] = useState(false);


  /* =======================================================
     Submit Registration
  ======================================================= */

  const handleFinish = async (
    values
  ) => {

    console.log(
      'Register:',
      values
    );


    /*
     * API connection comes in the next step.
     *
     * For now we validate the complete
     * registration form.
     */

    try {

      setSubmitting(true);


      const payload = {

        firstName:
          values.firstName.trim(),

        lastName:
          values.lastName.trim(),

        email:
          values.email
            .trim()
            .toLowerCase(),

        password:
          values.password,

      };


      console.log(
        'Registration payload:',
        payload
      );


      message.success(
        'Registration form validated successfully.'
      );


    } catch (error) {

      console.error(
        'Registration error:',
        error
      );


      message.error(
        'Unable to process registration.'
      );

    } finally {

      setSubmitting(false);

    }

  };


  /* =======================================================
     Back to Login
  ======================================================= */

  const handleLogin = () => {

    navigate(
      '/login'
    );

  };


  /* =======================================================
     Render
  ======================================================= */

  return (

    <div className="register-page">


      {/* ===================================================
          Background
      =================================================== */}

      <div className="register-background-grid" />

      <div
        className="
          register-background-glow
          register-glow-one
        "
      />

      <div
        className="
          register-background-glow
          register-glow-two
        "
      />


      <div className="register-container">


        {/* =================================================
            Product Logos
        ================================================= */}

        <ProductBrandBar />


        {/* =================================================
            Header
        ================================================= */}

        <div className="register-header">

          <div className="register-platform-icon">

            <BarChartOutlined />

          </div>


          <h1>
            Lotto Analytics
          </h1>


          <p>
            Advanced Lottery & Gaming Analytics
          </p>

        </div>


        {/* =================================================
            Register Card
        ================================================= */}

        <div className="register-card">


          <div className="register-card-header">

            <h2>
              Create Your Account
            </h2>


            <p>
              Join Lotto Analytics and access
              professional analytics tools
            </p>

          </div>


          {/* =================================================
              Registration Form
          ================================================= */}

          <Form

            layout="vertical"

            requiredMark={false}

            onFinish={
              handleFinish
            }

            autoComplete="off"

          >


            {/* =================================================
                Name
            ================================================= */}

            <div className="register-name-grid">


              <Form.Item

                label="First Name"

                name="firstName"

                rules={[

                  {
                    required: true,
                    message:
                      'Please enter your first name',
                  },

                  {
                    max: 50,
                    message:
                      'Maximum 50 characters',
                  },

                ]}

              >

                <Input

                  size="large"

                  prefix={
                    <UserOutlined />
                  }

                  placeholder="First name"

                  disabled={
                    submitting
                  }

                  maxLength={50}

                />

              </Form.Item>


              <Form.Item

                label="Last Name"

                name="lastName"

                rules={[

                  {
                    required: true,
                    message:
                      'Please enter your last name',
                  },

                  {
                    max: 50,
                    message:
                      'Maximum 50 characters',
                  },

                ]}

              >

                <Input

                  size="large"

                  prefix={
                    <UserOutlined />
                  }

                  placeholder="Last name"

                  disabled={
                    submitting
                  }

                  maxLength={50}

                />

              </Form.Item>


            </div>


            {/* =================================================
                Email
            ================================================= */}

            <Form.Item

              label="Email Address"

              name="email"

              normalize={
                (value) =>
                  typeof value === 'string'
                    ? value.trimStart()
                    : value
              }

              rules={[

                {
                  required: true,
                  message:
                    'Please enter your email address',
                },

                {
                  type: 'email',
                  message:
                    'Please enter a valid email address',
                },

                {
                  max: 255,
                  message:
                    'Maximum 255 characters',
                },

              ]}

            >

              <Input

                size="large"

                prefix={
                  <MailOutlined />
                }

                placeholder="Enter your email"

                disabled={
                  submitting
                }

                maxLength={255}

              />

            </Form.Item>


            {/* =================================================
                Password
            ================================================= */}

            <Form.Item

              label="Password"

              name="password"

              hasFeedback

              rules={[

                {
                  required: true,
                  message:
                    'Please create a password',
                },

                {
                  min: 8,
                  message:
                    'Password must be at least 8 characters',
                },

              ]}

            >

              <Input.Password

                size="large"

                prefix={
                  <LockOutlined />
                }

                placeholder="Create a password"

                disabled={
                  submitting
                }

              />

            </Form.Item>


            {/* =================================================
                Confirm Password
            ================================================= */}

            <Form.Item

              label="Confirm Password"

              name="confirmPassword"

              dependencies={[
                'password',
              ]}

              hasFeedback

              rules={[

                {
                  required: true,
                  message:
                    'Please confirm your password',
                },

                ({ getFieldValue }) => ({

                  validator(
                    _,
                    value
                  ) {

                    if (
                      !value ||
                      getFieldValue(
                        'password'
                      ) === value
                    ) {

                      return Promise.resolve();

                    }


                    return Promise.reject(
                      new Error(
                        'Passwords do not match'
                      )
                    );

                  },

                }),

              ]}

            >

              <Input.Password

                size="large"

                prefix={
                  <LockOutlined />
                }

                placeholder="Confirm your password"

                disabled={
                  submitting
                }

              />

            </Form.Item>


            {/* =================================================
                Terms
            ================================================= */}

            <Form.Item

              name="terms"

              valuePropName="checked"

              className="register-terms-item"

              rules={[

                {
                  validator:
                    (_, value) =>

                      value
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error(
                              'Please accept the Terms and Privacy Policy'
                            )
                          ),
                },

              ]}

            >

              <Checkbox
                disabled={
                  submitting
                }
              >

                I agree to the{' '}

                <button
                  type="button"
                  className="register-inline-link"
                >
                  Terms of Service
                </button>

                {' '}and{' '}

                <button
                  type="button"
                  className="register-inline-link"
                >
                  Privacy Policy
                </button>

              </Checkbox>

            </Form.Item>


            {/* =================================================
                Submit
            ================================================= */}

            <Form.Item
              className="register-submit-item"
            >

              <Button

                type="primary"

                htmlType="submit"

                size="large"

                block

                className="register-submit-button"

                icon={
                  <ArrowRightOutlined />
                }

                loading={
                  submitting
                }

                disabled={
                  submitting
                }

              >

                {
                  submitting
                    ? 'Creating Account...'
                    : 'Create Account'
                }

              </Button>

            </Form.Item>


          </Form>


          {/* =================================================
              Existing Account
          ================================================= */}

          <div className="register-account-divider">

            <span>
              Already have an account?
            </span>

          </div>


          <Button

            size="large"

            block

            className="register-login-button"

            icon={
              <LoginOutlined />
            }

            onClick={
              handleLogin
            }

            disabled={
              submitting
            }

          >

            Sign In

          </Button>


          {/* =================================================
              Security
          ================================================= */}

          <div className="register-security-message">

            <SafetyOutlined />

            <span>
              Your account information is securely protected
            </span>

          </div>


        </div>


        {/* =================================================
            Product Access Note
        ================================================= */}

        <div className="register-membership-preview">

          <div className="register-membership-title">
            Premium Analytics Platform
          </div>


          <div className="register-membership-products">

            <span>
              Lotto 6/49
            </span>

            <span>
              •
            </span>

            <span>
              Lotto MAX
            </span>

            <span>
              •
            </span>

            <span>
              Roulette
            </span>

          </div>

        </div>


        {/* =================================================
            Footer
        ================================================= */}

        <div className="register-footer">

          <Text>

            © {new Date().getFullYear()}
            {' '}
            Lotto Analytics

          </Text>


          <div className="register-footer-links">

            <span>
              Privacy
            </span>

            <span>
              Terms
            </span>

          </div>

        </div>


      </div>

    </div>

  );

}